module.exports = __webpack_public_path__ + "static/prostate-signs-24646666ab65e72583d862540046abd0.png";